import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { NavMenuItem } from './core/models/nav-menu-item.interface';
import { NavigationEnd, Router } from '@angular/router';
import {
  getBreadcrumbByTitle,
  getMenuByCode,
  getSubmenuByCode,
  MENU_ITEMS,
} from './constants/menus';
import { throwError } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { PageRequest } from './shared/models/page-request.interface';
import { KfRegistration } from './shared/models/kf-registration.interface';
import { Page } from './shared/models/page.interface';
import { KFConfiguration } from './kf-data-entry/models/kf-configuration.interface';

declare const gtag: Function;

const PAGES_WHITHOUT_LATERAL_MENU = [
  '/',
  '/kfreporting/kfconfiguration/summary-mappings',
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(private authService: AuthService,
              private router: Router,
              private titleService: Title) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();

    /** START : Code to Track Page View using gtag.js */
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects,
        });
      });
    /** END : Code to Track Page View  using gtag.js */

    //Add dynamic title for selected pages - Start
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        var title = this.getTitle(
          router.routerState,
          router.routerState.root
        ).join(' > ');
        titleService.setTitle(title);
      }
    });
    //Add dynamic title for selected pages - End
  }

  title = 'kf-platform-web';
  currentUrl = '/';
  breadcrumb1?: string;
  breadcrumb2?: string;
  title1?: string;
  title2?: string;
  code?: string;
  currentRoute?: string;
  allMenuItems: NavMenuItem[] = MENU_ITEMS;

  menuItemsByRole!: NavMenuItem[];
  submenuItems: NavMenuItem[] = [];
  showLateralMenuTitle = false;
  private kfcPage: PageRequest = {
    page: 0,
    size: 1,
    sort: 'year',
    direction: 'desc',
  };
  private page: PageRequest = {
    page: 0,
    size: 4,
    sort: 'year',
    direction: 'desc',
  };
  allKfRegistration?: Page<KfRegistration>;
  kfConfiguration?: Page<KFConfiguration>;

  ngOnInit(): void {
    this.loadLogin();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.currentUrl = e.url.split('?')[0];
        const urlParts = e.url
          .split('?')[0]
          .split('/')
          .filter((item) => item.length > 0);
        if (urlParts.length > 1) {
          const menuItem = getMenuByCode(urlParts[0]);
          if (menuItem) {
            const submenu = getSubmenuByCode(urlParts[1], menuItem);
            this.breadcrumb1 = menuItem?.breadcrumb_title;
            this.breadcrumb2 = submenu?.breadcrumb_title;
            this.title1 = submenu?.pageTitle;
            this.code = submenu?.help_item_code || submenu?.submenus?.[0].code;
            if (urlParts[2] || submenu?.submenus) {
              const selectedMenuOption = submenu?.submenus
                ?.filter((item) => item.link.includes(urlParts[2]))
                .pop();
              this.title2 = selectedMenuOption?.title;
              this.code = selectedMenuOption?.code;

              if (urlParts[3] || selectedMenuOption?.submenus) {
                const selectedSubmenu = selectedMenuOption?.submenus
                  ?.filter((item) => item.link.includes(urlParts[3]))
                  .pop();
                if (selectedSubmenu?.title.length) {
                  this.title2 = this.title2 + ' - ' + selectedSubmenu.title;
                  this.code = selectedSubmenu.code;
                }
              }
            }
            if (!this.title2) {
              this.title2 = submenu?.pageSubtitle;
            }
            if (!this.code) {
              this.code = submenu?.code;
            }
            const temporalMenu = JSON.parse(JSON.stringify(submenu?.submenus));
            this.submenuItems = this.filterSubMenuByRole(temporalMenu);
            this.showLateralMenuTitle = submenu?.showLateralMenuTitle || false;
          } else {
            const breadCrumbItem = getBreadcrumbByTitle(urlParts[0]);
            this.breadcrumb1 = breadCrumbItem?.breadcrumb_title;
            this.breadcrumb2 = breadCrumbItem?.breadcrumb_subtitle;
            this.title1 = breadCrumbItem?.pageTitle;
            this.title2 = breadCrumbItem?.pageSubtitle;
            this.code =
              breadCrumbItem?.help_item_code ||
              breadCrumbItem?.submenus?.[0].code;
          }
        }
      }
    });
  }

  loadMenu() {
    if (this.isLoggedIn()) {
      const menuByRoles = [] as NavMenuItem[];
      this.allMenuItems.forEach(
        item => {
          if (!item.roles || this.authService.userHasAnyRole(item.roles)) {
            const itemByRoles = {...item};
            itemByRoles.submenus = this.filterByRole(item.submenus);
            menuByRoles.push(itemByRoles);
          }
        }
      );
      
      this.menuItemsByRole = menuByRoles;
    }
  }

  filterMenu(menuByRoles: NavMenuItem[]) {
    if (this.allKfRegistration) {
      const kfReg = this.allKfRegistration;

      this.allMenuItems?.forEach((item) => {
        if ((!item.roles || this.authService.userHasAnyRole(item.roles))
          && this.filterMenuExceptTypeDataByData(kfReg,item, 'Cost', 'Validated', 'kfcharts')
        ) {
          const itemByRoles = { ...item };
          itemByRoles.submenus = this.filterByRole(item.submenus);
          
          this.filterSubMenuByData(kfReg, itemByRoles.submenus, 'Cost', 'Validated', 'Cost');

          menuByRoles.push(itemByRoles);
        }
      });
     
      
    }
  }

  loadLogin() {
    this.authService.$onLogin.subscribe((user) => {
      if (user) {
        this.loadMenu();
      }
    });
  }

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state: any, parent: any): any {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  showLateralMenu(): boolean {
    return !PAGES_WHITHOUT_LATERAL_MENU.includes(this.currentUrl);
  }

  filterSubMenuByRole(options: NavMenuItem[] | undefined): NavMenuItem[] {
    if (!options) {
      return [];
    }

    options.forEach((option) => {
      if (option.submenus) {
        option.submenus = this.filterSubMenuByRole(option.submenus);
      }
    });

    return options.filter(
      (option) =>
        !option?.roles || this.authService.userHasAnyRole(option.roles)
    );
  }

  filterByRole(options: NavMenuItem[] | undefined): NavMenuItem[] {
    if (!options) {
      return [];
    }
    return options.filter(
      (option) =>
        !option?.roles || this.authService.userHasAnyRole(option.roles)
    );
  }

  filterMenuExceptTypeDataByData(dataKfRegistration: Page<KfRegistration>,
          menuItem: NavMenuItem, 
          showExceptTypeData: string, 
          status: string, 
          menuCode: string): boolean {

    let dataExceptCost = dataKfRegistration.content
            ?.filter((value) => value.keyFigures != showExceptTypeData)
            .filter((value) => value.status == status);
    
    return dataExceptCost.length == 0 && menuItem.code == menuCode;

  }

  filterSubMenuByData(
    dataKfRegistration: Page<KfRegistration>,
    submenus: NavMenuItem[],
    typeData: string,
    status: string,
    menuCode: string
  ): void {
    let data = dataKfRegistration.content
      ?.filter((value) => value.keyFigures == typeData)
      .filter((value) => value.status == status);

    if (data.length == 0 && submenus) {
        submenus[0].submenus = submenus[0].submenus?.filter(
          (value) => value.title != menuCode
        );
    }
  }

  loadMenuOption(event: string): void {
    this.redirectTo(event || '/not-found');
  }

  logout(): void {
    this.authService.logout();
    this.allMenuItems = MENU_ITEMS;
    this.router.navigate(['/login']).catch((error) => throwError(error));
  }

  getUsername(): string {
    return this.authService.getUsername();
  }

  getSystem(): string {
    return this.authService.getSystem();
  }

  getCountry(): string {
    return this.authService.getCountry();
  }

  getUserRoles(): string[] {
    return this.authService.getUserRoles();
  }

  redirectTo(uri: string): void {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }
}
